import React, { useEffect, useState } from "react";
import { Field, FormikProvider, useFormik } from "formik";
import { Spin } from "antd";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomSelect from "../../../CustomControls/CustomSelect";
import { SVGICON } from "../../../constant/theme";
import { post } from "../../../helpers/api_helper";
import {
  POST_EquipmentUsageDelete,
  POST_EquipmentUsageInsert,
  POST_GetEquipmentUsageTCList,
  POST_GetMachinesDropDownList,
} from "../../../helpers/url_helper";
import {
  delete_Record,
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";

const TestingEquipmentUsageTab = () => {
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const [isLoading, setIsLoading] = useState(false);
  const [machineOptions, setMachineOptions] = useState([]);
  const [listOfTC, setListOfTC] = useState([]);
  const [listOfHistory, setListOfHistory] = useState([]);
  const [selectedTCs, setSelectedTCs] = useState([]); // InwardMaterialIDEncrypt of ticked rows

  const formik = useFormik({
    initialValues: { MachineIDEncrypt: "" },
  });
  const machineIDEncrypt = formik.values.MachineIDEncrypt;

  const getMachinesDDL = async () => {
    setIsLoading(true);
    await post(POST_GetMachinesDropDownList, {
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setMachineOptions(
            response?.MachinesDropDownList?.map((item) => ({
              label: item.MachineName,
              value: item.MachineIDEncrypt,
            })) ?? [],
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTCList = async (machineId) => {
    setIsLoading(true);
    await post(POST_GetEquipmentUsageTCList, {
      MachineIDEncrypt: machineId,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      LoginIDEncrypt: AuthUser?.LoginIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setListOfTC(response?.ListOfTC ?? []);
          setListOfHistory(response?.ListOfHistory ?? []);
        } else {
          setListOfTC([]);
          setListOfHistory([]);
          errorMessage(response?.Message);
        }
        setSelectedTCs([]);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getMachinesDDL();
  }, []);

  const handleMachineChange = (option) => {
    const value = option?.value ?? "";
    formik.setFieldValue("MachineIDEncrypt", value);
    if (value) {
      getTCList(value);
    } else {
      setListOfTC([]);
      setListOfHistory([]);
      setSelectedTCs([]);
    }
  };

  const toggleTC = (id) => {
    setSelectedTCs((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  const allSelected =
    listOfTC.length > 0 && selectedTCs.length === listOfTC.length;

  const toggleAll = () => {
    setSelectedTCs(
      allSelected ? [] : listOfTC.map((x) => x.InwardMaterialIDEncrypt),
    );
  };

  const handleSave = async () => {
    if (!machineIDEncrypt) {
      warningMessage("Select equipment.");
      return;
    }
    if (selectedTCs.length === 0) {
      warningMessage("Select at least one TC No.");
      return;
    }
    setIsLoading(true);
    await post(POST_EquipmentUsageInsert, {
      MachineIDEncrypt: machineIDEncrypt,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypt: AuthUser?.LoginIDEncrypt,
      ListOfInwardMaterialIDEncrypt: selectedTCs,
    })
      .then((response) => {
        setIsLoading(false);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          getTCList(machineIDEncrypt);
        } else {
          errorMessage(response?.Message);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleDeleteHistory = (testingResultLogBookIDEncrypt) => {
    delete_Record(
      POST_EquipmentUsageDelete,
      {
        TestingResultLogBookIDEncrypt: testingResultLogBookIDEncrypt,
        CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
        BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
        ModifiedByEncrypt: AuthUser?.LoginIDEncrypt,
      },
      setIsLoading,
      () => getTCList(machineIDEncrypt),
    );
  };

  return (
    <Spin spinning={isLoading} tip="Loading...">
      <FormikProvider value={formik}>
        <Row className="me-0">
          <Col xs={12} md={6} lg={4}>
            <Field
              name="MachineIDEncrypt"
              component={CustomSelect}
              label="Equipment"
              required
              placeholder="Select equipment"
              options={machineOptions}
              onChange={handleMachineChange}
              menuPosition="fixed"
            />
          </Col>
        </Row>
      </FormikProvider>

      {machineIDEncrypt && (
        <>
          <div className="table-responsive active-projects style-1 shorting">
            <div className="dataTables_wrapper no-footer">
              <table className="table dataTable no-footer mb-0">
                <thead>
                  <tr>
                    <th width="6%">
                      <div className="form-check d-flex justify-content-center">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={allSelected}
                          onChange={toggleAll}
                          disabled={listOfTC.length === 0}
                          aria-label="Select all TC Nos"
                        />
                      </div>
                    </th>
                    <th width="30%">TC No</th>
                    <th style={{ textAlign: "left" }}>
                      History (Equipment Used On)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {listOfTC.length > 0 ? (
                    listOfTC.map((tc) => {
                      const history = listOfHistory.filter(
                        (h) =>
                          h.InwardMaterialIDEncrypt ===
                          tc.InwardMaterialIDEncrypt,
                      );
                      return (
                        <tr
                          key={tc.InwardMaterialIDEncrypt}
                          onClick={() => toggleTC(tc.InwardMaterialIDEncrypt)}
                        >
                          <td>
                            <div className="form-check d-flex justify-content-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={selectedTCs.includes(
                                  tc.InwardMaterialIDEncrypt,
                                )}
                                onChange={() =>
                                  toggleTC(tc.InwardMaterialIDEncrypt)
                                }
                                onClick={(e) => e.stopPropagation()}
                                aria-label={`Select ${tc.TCNo}`}
                              />
                            </div>
                          </td>
                          <td className="fw-bold">{tc.TCNo}</td>
                          <td
                            style={{ textAlign: "left" }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {history.length > 0 ? (
                              history.map((h, i) => (
                                <React.Fragment
                                  key={h.TestingResultLogBookIDEncrypt}
                                >
                                  {i > 0 && (
                                    <span className="mx-3 text-muted">|</span>
                                  )}
                                  <span className="d-inline-flex align-items-center">
                                    {h.UsedOn}
                                    {h.CanDelete && (
                                      <Link
                                        to="#"
                                        className="icon-box icon-box-md ms-1"
                                        title="Delete"
                                        onClick={() =>
                                          handleDeleteHistory(
                                            h.TestingResultLogBookIDEncrypt,
                                          )
                                        }
                                      >
                                        {SVGICON.DeleteDanger}
                                      </Link>
                                    )}
                                  </span>
                                </React.Fragment>
                              ))
                            ) : (
                              <span className="text-muted">Not used yet</span>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={3} className="text-center text-muted">
                        No TC No is allocated to you.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="rdlb-savebar">
            <button
              type="button"
              className="btn btn-primary btn-sm me-2"
              onClick={handleSave}
              disabled={selectedTCs.length === 0 || isLoading}
            >
              <i className="fa-solid fa-floppy-disk"></i> Save
            </button>
          </div>
        </>
      )}
    </Spin>
  );
};

export default TestingEquipmentUsageTab;
